module.exports = __webpack_public_path__ + "img/vue_icon.11e81d53.svg";